var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotesRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04134 11.6666C6.04134 11.3214 6.32116 11.0416 6.66634 11.0416L13.333 11.0416C13.6782 11.0416 13.958 11.3214 13.958 11.6666C13.958 12.0118 13.6782 12.2916 13.333 12.2916L6.66634 12.2916C6.32116 12.2916 6.04134 12.0118 6.04134 11.6666Z",
    fill: "#EA011D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04134 8.33325C6.04134 7.98807 6.32116 7.70825 6.66634 7.70825H8.33301C8.67819 7.70825 8.95801 7.98807 8.95801 8.33325C8.95801 8.67843 8.67819 8.95825 8.33301 8.95825H6.66634C6.32116 8.95825 6.04134 8.67843 6.04134 8.33325Z",
    fill: "#EA011D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04134 14.9999C6.04134 14.6547 6.32116 14.3749 6.66634 14.3749H9.99967C10.3449 14.3749 10.6247 14.6547 10.6247 14.9999C10.6247 15.3451 10.3449 15.6249 9.99967 15.6249H6.66634C6.32116 15.6249 6.04134 15.3451 6.04134 14.9999Z",
    fill: "#EA011D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33301 0.208252C8.67819 0.208252 8.95801 0.488074 8.95801 0.833252V4.16659C8.95801 4.51176 8.67819 4.79158 8.33301 4.79158C7.98783 4.79158 7.70801 4.51176 7.70801 4.16659V3.12492H4.99967C4.42438 3.12492 3.95801 3.59129 3.95801 4.16659V16.6666C3.95801 17.2419 4.42438 17.7083 4.99967 17.7083H14.9997C15.575 17.7083 16.0413 17.2419 16.0413 16.6666V4.16659C16.0413 3.59129 15.575 3.12492 14.9997 3.12492H12.083C11.7378 3.12492 11.458 2.8451 11.458 2.49992C11.458 2.15474 11.7378 1.87492 12.083 1.87492H14.9997C16.2653 1.87492 17.2913 2.90093 17.2913 4.16659V16.6666C17.2913 17.9322 16.2653 18.9583 14.9997 18.9583H4.99967C3.73402 18.9583 2.70801 17.9322 2.70801 16.6666V4.16659C2.70801 2.90093 3.73402 1.87492 4.99967 1.87492H7.70801V0.833252C7.70801 0.488074 7.98783 0.208252 8.33301 0.208252Z",
    fill: "#EA011D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesRed);
export default __webpack_public_path__ + "static/media/notes-red.ff9c1d2859e9e7cb310283c7c7385be4.svg";
export { ForwardRef as ReactComponent };